import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { NavLink } from "react-router-dom";
import { Nav, Collapse } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import FeatherIcon from "feather-icons-react";

import { deviceApi } from "../../../modules/identity/reducers/identitySlice";

import userPlaceholder from "../../../assets/images/users/ic_user.jpg";
import { isAllowed } from "../../../routes/Router";

const Sidebar = (props) => {
  const [state, setState] = useState({});
  const [cstate, csetState] = useState({});

  const dispatch = useDispatch();
  
  const settings = useSelector((state) => state.settingReducer);
  const identity = useSelector((state) => state.identityReducer.identity);
  const roleName = useSelector((state) => state.identityReducer?.identity?.role?.label?.toUpperCase() );
  /*--------------------------------------------------------------------------------*/
  /*To Expand SITE_LOGO With Sidebar-Menu on Hover                                  */
  /*--------------------------------------------------------------------------------*/
  const expandLogo = () => {
    document.getElementById("logobg").classList.toggle("expand-logo");
  };
  /*--------------------------------------------------------------------------------*/
  /*Verifies if routeName is the one active (in browser input)                      */
  /*--------------------------------------------------------------------------------*/

  /*--------------------------------------------------------------------------------*/
  /*Its for scroll to to                    */
  /*--------------------------------------------------------------------------------*/

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const showMobilemenu = () => {
    document.getElementById("main-wrapper").classList.toggle("show-sidebar");
  };

  const toggle = () => {
    setState((state) => ({ collapse: !state.collapse }));
  };

  return (
    <aside
      className="left-sidebar"
      id="sidebarbg"
      data-sidebarbg={settings.activeSidebarBg}
      onMouseEnter={expandLogo.bind(null)}
      onMouseLeave={expandLogo.bind(null)}
    >
      <div className="scroll-sidebar">
        <PerfectScrollbar className="sidebar-nav">
          {/*--------------------------------------------------------------------------------*/}
          {/* Sidebar Menus will go here                                                */}
          {/*--------------------------------------------------------------------------------*/}
          <Nav id="sidebarnav">
            <li className="sidebar-item user-profile">
              <span
                onClick={toggle}
                className="sidebar-link has-arrow"
                aria-expanded="false"
              >
                <img src={identity.avatar ? identity.avatar : userPlaceholder} alt="user" />
                <span className="hide-menu user-name">{identity.firstname} {identity.lastname}</span>
              </span>
              <Collapse isOpen={state.collapse}>
                <ul>
                  <li>
                    <NavLink
                      to='/profile'
                      className="sidebar-link p-0"
                    >
                      <span className="hide-menu">My Profile</span>
                    </NavLink>
                  </li>
                  {/* <li>
                    <a href="/calendar" className="sidebar-link p-0">
                      My Balance
                    </a>
                  </li>
                  <li>
                    <a href="/email" className="sidebar-link p-0">
                      Inbox
                    </a>
                  </li> */}
                  <li>
                    <a href="/login" className="sidebar-link p-0" onClick={(event) => {
                      dispatch(deviceApi.logout());
                      event.preventDefault();
                    }}>
                      Logout
                    </a>
                  </li>
                </ul>
              </Collapse>
            </li>
            {props.routes.map((prop, key) => {
              if (prop.redirect) {
                return null;
              } else if (prop.navlabel) {
                return (
                  <li className="nav-small-cap" key={key}>
                    <i className={prop.icon}></i>
                    <span className="hide-menu">{prop.name}</span>
                  </li>
                );
                /*--------------------------------------------------------------------------------*/
                /* Child Menus wiil be goes here                                                    */
                /*--------------------------------------------------------------------------------*/
              } else if (prop.collapse) {
                let firstdd = {};
                firstdd[prop.state] = !state[prop.state];

                return (
                  <li
                    className={"sidebar-item"}
                    key={key}
                  >
                    <span
                      data-toggle="collapse"
                      className="sidebar-link has-arrow"
                      aria-expanded={state[prop.state]}
                      onClick={() => setState(firstdd)}
                    >
                      <FeatherIcon icon={prop.icon} />
                      {/* <i className={prop.icon} /> */}
                      <span className="hide-menu">{prop.name}</span>
                    </span>
                    <Collapse isOpen={state[prop.state]}>
                      <ul className="first-level">
                        {prop.child.map((prop, key) => {
                          if (prop.redirect) return null;

                          /*--------------------------------------------------------------------------------*/
                          /* Child Sub-Menus wiil be goes here                                                    */
                          /*--------------------------------------------------------------------------------*/

                          if (prop.collapse) {
                            let seconddd = {};
                            seconddd[prop["cstate"]] = !cstate[prop.cstate];
                            return (
                              <li
                                className={"sidebar-item"}
                                key={key}
                              >
                                <span
                                  data-toggle="collapse"
                                  className="sidebar-link has-arrow"
                                  aria-expanded={cstate[prop.cstate]}
                                  onClick={() => csetState(seconddd)}
                                >
                                  <i className={prop.icon} />
                                  <span className="hide-menu">{prop.name}</span>
                                </span>
                                <Collapse isOpen={cstate[prop.cstate]}>
                                  <ul className="second-level">
                                    {prop.subchild.map((prop, key) => {
                                      if (prop.redirect) return null;
                                      return isAllowed(prop.path, roleName) ? (
                                        <li
                                          className={"sidebar-item"}
                                          key={key}
                                        >
                                          <NavLink
                                            to={prop.path}
                                            activeclassname="active"
                                            className="sidebar-link"
                                          >
                                            <i className={prop.icon} />
                                            <span className="hide-menu">
                                              {" "}
                                              {prop.name}
                                            </span>
                                          </NavLink>
                                        </li>
                                      ) : <></>;
                                    })}
                                  </ul>
                                </Collapse>
                              </li>
                            );
                          } else {
                            return isAllowed(prop.path, roleName) ? (
                              <li
                                onClick={showMobilemenu && scrollTop}
                                className={
                                  (prop.pro ? " active active-pro" : "") +
                                  " sidebar-item"
                                }
                                key={key}
                              >
                                <NavLink
                                  to={prop.path}
                                  className="sidebar-link"
                                  activeclassname="active"
                                >
                                  <i className={prop.icon} />
                                  <span className="hide-menu">{prop.name}</span>
                                </NavLink>
                              </li>
                            ) : <></>;
                          }
                        })}
                      </ul>
                    </Collapse>
                  </li>
                );
              } else {
                return isAllowed(prop.path, roleName) ? (
                  /*--------------------------------------------------------------------------------*/
                  /* Adding Sidebar Item                                                            */
                  /*--------------------------------------------------------------------------------*/
                  <li
                    onClick={scrollTop}
                    className={
                      (prop.pro ? " active active-pro" : "") +
                      " sidebar-item"
                    }
                    key={key}
                  >
                    <NavLink
                      to={prop.path}
                      className="sidebar-link"
                      activeclassname="active"
                    >
                      <FeatherIcon icon={prop.icon} />
                      {/* <i className={prop.icon} /> */}
                      <span className="hide-menu">{prop.name}</span>
                    </NavLink>
                  </li>
                ) : null;
              }
            })}
          </Nav>
        </PerfectScrollbar>
      </div>
    </aside>
  );
};

export default Sidebar;
